export class Convert {
  static mimeTypelist: {
    'application/andrew-inset': string[];
    'application/applixware': string[];
    'application/atom+xml': string[];
    'application/atomcat+xml': string[];
    'application/atomdeleted+xml': string[];
    'application/atomsvc+xml': string[];
    'application/atsc-dwd+xml': string[];
    'application/atsc-held+xml': string[];
    'application/atsc-rsat+xml': string[];
    'application/bdoc': string[];
    'application/calendar+xml': string[];
    'application/ccxml+xml': string[];
    'application/cdfx+xml': string[];
    'application/cdmi-capability': string[];
    'application/cdmi-container': string[];
    'application/cdmi-domain': string[];
    'application/cdmi-object': string[];
    'application/cdmi-queue': string[];
    'application/cu-seeme': string[];
    'application/dash+xml': string[];
    'application/davmount+xml': string[];
    'application/docbook+xml': string[];
    'application/dssc+der': string[];
    'application/dssc+xml': string[];
    'application/ecmascript': string[];
    'application/emma+xml': string[];
    'application/emotionml+xml': string[];
    'application/epub+zip': string[];
    'application/exi': string[];
    'application/express': string[];
    'application/fdt+xml': string[];
    'application/font-tdpfr': string[];
    'application/geo+json': string[];
    'application/gml+xml': string[];
    'application/gpx+xml': string[];
    'application/gxf': string[];
    'application/gzip': string[];
    'application/hjson': string[];
    'application/hyperstudio': string[];
    'application/inkml+xml': string[];
    'application/ipfix': string[];
    'application/its+xml': string[];
    'application/java-archive': string[];
    'application/java-serialized-object': string[];
    'application/java-vm': string[];
    'application/javascript': string[];
    'application/json': string[];
    'application/json5': string[];
    'application/jsonml+json': string[];
    'application/ld+json': string[];
    'application/lgr+xml': string[];
    'application/lost+xml': string[];
    'application/mac-binhex40': string[];
    'application/mac-compactpro': string[];
    'application/mads+xml': string[];
    'application/manifest+json': string[];
    'application/marc': string[];
    'application/marcxml+xml': string[];
    'application/mathematica': string[];
    'application/mathml+xml': string[];
    'application/mbox': string[];
    'application/mediaservercontrol+xml': string[];
    'application/metalink+xml': string[];
    'application/metalink4+xml': string[];
    'application/mets+xml': string[];
    'application/mmt-aei+xml': string[];
    'application/mmt-usd+xml': string[];
    'application/mods+xml': string[];
    'application/mp21': string[];
    'application/mp4': string[];
    'application/msword': string[];
    'application/mxf': string[];
    'application/n-quads': string[];
    'application/n-triples': string[];
    'application/node': string[];
    'application/octet-stream': string[];
    'application/oda': string[];
    'application/oebps-package+xml': string[];
    'application/ogg': string[];
    'application/omdoc+xml': string[];
    'application/onenote': string[];
    'application/oxps': string[];
    'application/p2p-overlay+xml': string[];
    'application/patch-ops-error+xml': string[];
    'application/pdf': string[];
    'application/pgp-encrypted': string[];
    'application/pgp-signature': string[];
    'application/pics-rules': string[];
    'application/pkcs10': string[];
    'application/pkcs7-mime': string[];
    'application/pkcs7-signature': string[];
    'application/pkcs8': string[];
    'application/pkix-attr-cert': string[];
    'application/pkix-cert': string[];
    'application/pkix-crl': string[];
    'application/pkix-pkipath': string[];
    'application/pkixcmp': string[];
    'application/pls+xml': string[];
    'application/postscript': string[];
    'application/provenance+xml': string[];
    'application/pskc+xml': string[];
    'application/raml+yaml': string[];
    'application/rdf+xml': string[];
    'application/reginfo+xml': string[];
    'application/relax-ng-compact-syntax': string[];
    'application/resource-lists+xml': string[];
    'application/resource-lists-diff+xml': string[];
    'application/rls-services+xml': string[];
    'application/route-apd+xml': string[];
    'application/route-s-tsid+xml': string[];
    'application/route-usd+xml': string[];
    'application/rpki-ghostbusters': string[];
    'application/rpki-manifest': string[];
    'application/rpki-roa': string[];
    'application/rsd+xml': string[];
    'application/rss+xml': string[];
    'application/rtf': string[];
    'application/sbml+xml': string[];
    'application/scvp-cv-request': string[];
    'application/scvp-cv-response': string[];
    'application/scvp-vp-request': string[];
    'application/scvp-vp-response': string[];
    'application/sdp': string[];
    'application/senml+xml': string[];
    'application/sensml+xml': string[];
    'application/set-payment-initiation': string[];
    'application/set-registration-initiation': string[];
    'application/shf+xml': string[];
    'application/sieve': string[];
    'application/smil+xml': string[];
    'application/sparql-query': string[];
    'application/sparql-results+xml': string[];
    'application/srgs': string[];
    'application/srgs+xml': string[];
    'application/sru+xml': string[];
    'application/ssdl+xml': string[];
    'application/ssml+xml': string[];
    'application/swid+xml': string[];
    'application/tei+xml': string[];
    'application/thraud+xml': string[];
    'application/timestamped-data': string[];
    'application/toml': string[];
    'application/trig': string[];
    'application/ttml+xml': string[];
    'application/ubjson': string[];
    'application/urc-ressheet+xml': string[];
    'application/urc-targetdesc+xml': string[];
    'application/voicexml+xml': string[];
    'application/wasm': string[];
    'application/widget': string[];
    'application/winhlp': string[];
    'application/wsdl+xml': string[];
    'application/wspolicy+xml': string[];
    'application/xaml+xml': string[];
    'application/xcap-att+xml': string[];
    'application/xcap-caps+xml': string[];
    'application/xcap-diff+xml': string[];
    'application/xcap-el+xml': string[];
    'application/xcap-ns+xml': string[];
    'application/xenc+xml': string[];
    'application/xhtml+xml': string[];
    'application/xliff+xml': string[];
    'application/xml': string[];
    'application/xml-dtd': string[];
    'application/xop+xml': string[];
    'application/xproc+xml': string[];
    'application/xslt+xml': string[];
    'application/xspf+xml': string[];
    'application/xv+xml': string[];
    'application/yang': string[];
    'application/yin+xml': string[];
    'application/zip': string[];
    'audio/3gpp': string[];
    'audio/adpcm': string[];
    'audio/amr': string[];
    'audio/basic': string[];
    'audio/midi': string[];
    'audio/mobile-xmf': string[];
    'audio/mp3': string[];
    'audio/mp4': string[];
    'audio/mpeg': string[];
    'audio/ogg': string[];
    'audio/s3m': string[];
    'audio/silk': string[];
    'audio/wav': string[];
    'audio/wave': string[];
    'audio/webm': string[];
    'audio/xm': string[];
    'font/collection': string[];
    'font/otf': string[];
    'font/ttf': string[];
    'font/woff': string[];
    'font/woff2': string[];
    'image/aces': string[];
    'image/apng': string[];
    'image/avif': string[];
    'image/bmp': string[];
    'image/cgm': string[];
    'image/dicom-rle': string[];
    'image/emf': string[];
    'image/fits': string[];
    'image/g3fax': string[];
    'image/gif': string[];
    'image/heic': string[];
    'image/heic-sequence': string[];
    'image/heif': string[];
    'image/heif-sequence': string[];
    'image/hej2k': string[];
    'image/hsj2': string[];
    'image/ief': string[];
    'image/jls': string[];
    'image/jp2': string[];
    'image/jpeg': string[];
    'image/jph': string[];
    'image/jphc': string[];
    'image/jpm': string[];
    'image/jpx': string[];
    'image/jxr': string[];
    'image/jxra': string[];
    'image/jxrs': string[];
    'image/jxs': string[];
    'image/jxsc': string[];
    'image/jxsi': string[];
    'image/jxss': string[];
    'image/ktx': string[];
    'image/ktx2': string[];
    'image/png': string[];
    'image/sgi': string[];
    'image/svg+xml': string[];
    'image/t38': string[];
    'image/tiff': string[];
    'image/tiff-fx': string[];
    'image/webp': string[];
    'image/wmf': string[];
    'message/disposition-notification': string[];
    'message/global': string[];
    'message/global-delivery-status': string[];
    'message/global-disposition-notification': string[];
    'message/global-headers': string[];
    'message/rfc822': string[];
    'model/3mf': string[];
    'model/gltf+json': string[];
    'model/gltf-binary': string[];
    'model/iges': string[];
    'model/mesh': string[];
    'model/mtl': string[];
    'model/obj': string[];
    'model/step+xml': string[];
    'model/step+zip': string[];
    'model/step-xml+zip': string[];
    'model/stl': string[];
    'model/vrml': string[];
    'model/x3d+binary': string[];
    'model/x3d+fastinfoset': string[];
    'model/x3d+vrml': string[];
    'model/x3d+xml': string[];
    'model/x3d-vrml': string[];
    'text/cache-manifest': string[];
    'text/calendar': string[];
    'text/coffeescript': string[];
    'text/css': string[];
    'text/csv': string[];
    'text/html': string[];
    'text/jade': string[];
    'text/jsx': string[];
    'text/less': string[];
    'text/markdown': string[];
    'text/mathml': string[];
    'text/mdx': string[];
    'text/n3': string[];
    'text/plain': string[];
    'text/richtext': string[];
    'text/rtf': string[];
    'text/sgml': string[];
    'text/shex': string[];
    'text/slim': string[];
    'text/spdx': string[];
    'text/stylus': string[];
    'text/tab-separated-values': string[];
    'text/troff': string[];
    'text/turtle': string[];
    'text/uri-list': string[];
    'text/vcard': string[];
    'text/vtt': string[];
    'text/xml': string[];
    'text/yaml': string[];
    'video/3gpp': string[];
    'video/3gpp2': string[];
    'video/h261': string[];
    'video/h263': string[];
    'video/h264': string[];
    'video/iso.segment': string[];
    'video/jpeg': string[];
    'video/jpm': string[];
    'video/mj2': string[];
    'video/mp2t': string[];
    'video/mp4': string[];
    'video/mpeg': string[];
    'video/ogg': string[];
    'video/quicktime': string[];
    'video/webm': string[];
  };
  static mimeTypes: Record<string, string[]> = {
    'application/json': ['json'],
    'application/pdf': ['pdf'],
    'application/zip': ['zip'],
    'application/x-7z-compressed': ['7z'],
    'application/x-rar-compressed': ['rar'],
    'application/x-tar': ['tar'],
    'application/gzip': ['gz'],
    'application/msword': ['doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['docx'],
    'application/vnd.ms-excel': ['xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['xlsx'],
    'application/vnd.ms-powerpoint': ['ppt'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['pptx'],
    'application/octet-stream': ['bin', 'exe', 'dll'],
    'application/x-www-form-urlencoded': ['form'],
    'application/xml': ['xml'],
    'text/plain': ['txt'],
    'text/html': ['html', 'htm'],
    'text/css': ['css'],
    'text/javascript': ['js'],
    'application/javascript': ['js'],
    'image/jpeg': ['jpg', 'jpeg'],
    'image/png': ['png'],
    'image/gif': ['gif'],
    'image/bmp': ['bmp'],
    'image/webp': ['webp'],
    'image/svg+xml': ['svg'],
    'image/tiff': ['tif', 'tiff'],
    'image/x-icon': ['ico'],
    'audio/mpeg': ['mp3'],
    'audio/wav': ['wav'],
    'audio/ogg': ['ogg'],
    'audio/aac': ['aac'],
    'audio/x-aiff': ['aif', 'aiff'],
    'audio/x-m4a': ['m4a'],
    'video/mp4': ['mp4'],
    'video/webm': ['webm'],
    'video/ogg': ['ogv'],
    'video/x-msvideo': ['avi'],
    'video/x-flv': ['flv'],
    'video/mpeg': ['mpeg', 'mpg'],
    'video/quicktime': ['mov'],
    'video/x-matroska': ['mkv'],
    'font/otf': ['otf'],
    'font/ttf': ['ttf'],
    'font/woff': ['woff'],
    'font/woff2': ['woff2'],
    'application/vnd.apple.installer+xml': ['mpkg'],
    'application/x-shockwave-flash': ['swf'],
    'application/x-java-archive': ['jar'],
    'application/vnd.android.package-archive': ['apk'],
    'application/x-debian-package': ['deb'],
    'application/x-rpm': ['rpm'],
    'application/x-bzip': ['bz'],
    'application/x-bzip2': ['bz2'],
    'application/x-lzma': ['lzma'],
    'application/x-xz': ['xz'],
    'application/vnd.api+json': ['jsonapi'],
    'application/x-yaml': ['yaml', 'yml'],
    'application/x-sql': ['sql'],
  };

  static getExtension(mimeType: string): string[] | null {
    return this.mimeTypes[mimeType] || null;
  }
}
